import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';

import Field from '@/../bower_components/teknisavuecomponents/assets/interfaces/Field';
import TkForm from '@/../bower_components/teknisavuecomponents/components/TkForm.vue';
import EditableTable from '@/../bower_components/teknisavuecomponents/components/grids/EditableTable.vue';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';

import EditableTableColumn from '@/../bower_components/teknisavuecomponents/assets/interfaces/EditableTableColumn';
import EstruturaController from '@/assets/ts/controller/EstruturaController';
import Processo from '@/assets/ts/interfaces/Processo';
import ProcessoController from '@/assets/ts/controller/ProcessoController';
import FasePopup from '../FasePopup/FasePopup.vue';



@Component({
  name: 'ProcessoPopup',
  components: {
    TkForm,
    EditableTable,
    FasePopup,
  },
})
class ProcessoPopup extends Vue {
  // #region [ PROPS ]
  @Prop({ default: () => {} })
  private readonly row: Processo;

  @Prop({ default: false })
  private readonly value: boolean;
  // #endregion

  // #region [ EVENTS ]
  @Emit('input')
  private emitInput(value: boolean) {}
  // #endregion

  // #region [ DATA ]
  private readonly DEFAULT_TITLE = 'Processo';

  private internalValue = false;

  private loading = {
    fases: false,
  };

  private lastLoadedNrProcesso: string = null;

  private fasePopup = {
    show: false,
    row: null as any,
  };

  private form = {
    defaultRow: {
      a: 10,
    } as const,
    fields: [
      {
        name: 'NMPROCESSO',
        label: 'Nome',
        type: 'text',
        size: 12,
      },
      {
        name: 'DSLOCALIDADE',
        label: 'Localidade',
        type: 'text',
        size: 12,
        md: 4,
      },
      {
        name: 'VRSALARIO',
        label: 'Salário',
        type: 'number',
        size: 12,
        md: 2,
      },
      {
        name: 'DTSOLICITA',
        label: 'Data de Solicitação',
        type: 'text',
        size: 6,
        md: 3,
      },
      {
        name: 'DTLIMSOLICITA',
        label: 'Data Limite',
        type: 'text',
        size: 6,
        md: 3,
      },
      {
        name: 'NMSOLICITA',
        label: 'Solicitante',
        type: 'text',
        size: 12,
      },
      {
        name: 'NMRESPONSAVEL',
        label: 'Responsável',
        type: 'text',
        size: 12,
      },
      {
        name: 'DSSTATUS',
        label: 'Status',
        type: 'text',
        size: 12,
        md: 6,
      },
      {
        name: 'NMFASE',
        label: 'Fase Atual',
        type: 'text',
        size: 12,
        md: 6,
      },
      {
        name: 'DSMOTIVO',
        label: 'Motivo',
        type: 'text',
        size: 12,
      },
      {
        name: 'NMOCUPACAOH',
        label: 'Ocupação',
        type: 'text',
        size: 12,
        md: 6,
      },
      {
        name: 'NMESTRUTURAH',
        label: 'Estrutura Gerencial',
        type: 'text',
        size: 12,
        md: 6,
      },
      {
        name: 'NRVAGAS',
        label: 'Vagas',
        type: 'number',
        size: 12,
        md: 6,
      },
      {
        name: 'NMTEMPLATE',
        label: 'Template',
        type: 'text',
        size: 12,
        md: 6,
      },
      {
        name: 'DSDESCRICAO',
        label: 'Descrição',
        type: 'textarea',
        rows: 3,
        size: 12,
      },
    ] as Field[],
    row: {} as any,
  };

  private grid = {
    columns: [
      {
        value: 'NMFASE',
        text: 'Nome da Fase',
      },
      {
        value: 'VRFASE',
        text: 'Valor da Fase',
      },
      {
        value: 'NMCRITERIORESUL',
        text: 'Critério',
      },
      {
        value: 'IDOBRIGATORIO',
        text: 'Fase Obrigatória?',
        type: 'select',
        valueField: 'value',
        descriptionField: 'description',
        items: [
          {
            value: 'S',
            description: 'Sim',
          },
          {
            value: 'N',
            description: 'Não',
          },
        ],
      },
      {
        value: 'NRDURACAO',
        text: 'Duração',
      },
      {
        value: 'NRPESO',
        text: 'Peso',
      },
    ] as EditableTableColumn[],
    rows: [],
  };
  // #endregion

  // #region [ COMPUTED ]
  private get isLoading(): boolean {
    const loadingValues = Object.values(this.loading);
    const internalLoading = Util.oneTrue(...loadingValues);

    return internalLoading;
  }

  private get cardTitle(): string {
    const title = this.row ?
      `${this.DEFAULT_TITLE} - ${this.row.NMPROCESSO}` :
      this.DEFAULT_TITLE;

    return title;
  }
  // #endregion

  // #region [ LIFECYCLE ]
  private created() {
    //
  }
  // #endregion

  // #region [ WATCHERS ]
  @Watch('row', { immediate: true })
  private rowOnChange() {
    this.createFormRow();
  }

  @Watch('value', { immediate: true })
  private valueOnChange() {
    this.internalValue = this.value;

    if (this.internalValue) {
      if (this.lastLoadedNrProcesso !== this.row.NRPROCESSO) {
        this.loadFases();
      }
    }
  }
  // #endregion

  // #region [ METHODS ]
  private closeDialog(): void {
    this.internalValue = false;
    this.emitInput(this.internalValue);

    this.lastLoadedNrProcesso = this.row.NRPROCESSO;
  }

  private createFormRow(): void {
    this.form.row = {
      ...this.form.defaultRow,
      ...this.row || {},
    };
  }

  private async loadFases(): Promise<void> {
    const nrTemplate = this.row.NRTEMPLATE;
    const nrProcesso = this.row.NRPROCESSO;

    this.loading.fases = true;
    this.grid.rows = [];

    try {
      const fases = await ProcessoController.getFasesTemplate(nrTemplate, false);

      fases.forEach((fase) => {
        fase.NRPROCESSO = nrProcesso;
      });

      if (nrProcesso === this.row.NRPROCESSO) {
        this.grid.rows = fases;
      }
    } finally {
      this.loading.fases = false;
    }
  }

  private faseRowOnClick(row: any): void {
    this.openFasePopup(row);
  }

  private openFasePopup(row: any): void {
    this.fasePopup.show = true;
    this.fasePopup.row = row;
  }
  // #endregion
}

export default ProcessoPopup;
